
import { getToken } from '@/utils/cookies'

export interface UserState{
    token: string
    userInfo:any
}
export interface UserInfo{
  account:string
  avatar:string
  email:string
  notify1:string
  notify2:string
  status:number
  stno:string
  username:string
  usertype:string
}

export const state: UserState = {
  token: getToken() || '',
  userInfo : {
    userinfo:{
      username:'',
      avatar:'',
      // 0超级管理员, 1管理员, 2成员, 3院系管理员, 4督导
      role: '',
    },
    schooleinfo:{
      name: '',
      logo:''
    }
  }
}
